import { createClient } from '@supabase/supabase-js';

/**
 * Supabase client initialization
 * Uses environment variables: REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY
 * Falls back to empty strings if not provided (useful for demo/offline mode)
 *
 * IMPORTANT: We provide a custom no-op lock function to bypass navigator.locks.
 * The Web Locks API causes orphaned locks from React Strict Mode double-mounts,
 * tab crashes, and page refreshes — resulting in 5-10+ second auth hangs.
 * Since this is a single-user hotel app (not multi-tab concurrent), we don't
 * need cross-tab lock coordination.
 */
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    lock: async (name, acquireTimeout, fn) => {
      // Simple no-op lock: just run the function immediately.
      // Bypasses navigator.locks which causes orphaned lock hangs.
      return await fn();
    },
  },
});
